const CDN = "https://pub-fe12241b7bb041a784ec4049e068ea80.r2.dev";

// ── Boîtes de packs ──────────────────────────────────────────────────────────
export const BOX = {
  std:      "https://i.postimg.cc/vBT0vn4f/Chat-GPT-Image-Jun-16-2026-06-12-04-PM.png",
  premium:  "https://i.postimg.cc/LhKvR0NY/Chat-GPT-Image-Jun-16-2026-06-14-21-PM.png",
  familier: "https://i.postimg.cc/TY1TWN2y/Chat-GPT-Image-16-juin-2026-18-18-32.png",
};

// ── PP (Profile Pictures) débloquées par familier ────────────────────────────
export const PP_IMGS: Record<string, string> = {
  "Dobberman-PP-1": `${CDN}/PP-Dobberman-1.png`,
  "Dobberman-PP-2": `${CDN}/PP-Dobberman-2.png`,
  "Dobberman-PP-3": `${CDN}/PP-Dobberman-3.png`,
};

// Maps un familier → ses PP disponibles (à montrer quand le familier est unlocked)
export const FAMILIAR_PPS: Record<string, string[]> = {
  "Dobberman": ["Dobberman-PP-1", "Dobberman-PP-2", "Dobberman-PP-3"],
};

// ── PNGs calques full-size (superposés pixel-perfect sur Character.png) ───────
// Ordre d'affichage (z-index croissant) : ball → familiar → character → shoes → top → head
export const LAYER_IMGS: Record<string, string> = {
  // Ball
  "Beach Plastic Ball":  `${CDN}/Ball-Common-BeachPlasticBall.png`,
  "Geometric Style":     `${CDN}/Ball-Common-GeometricStyle.png`,
  "Vintage Ball":        `${CDN}/Ball-Epic-VintageBall.png`,
  "Power Ball":          `${CDN}/Ball-Legendary-PowerBall.png`,
  "World Cup 26":        `${CDN}/Ball-Rare-WorldCup26.png`,
  // Familiar
  "Dobberman":           `${CDN}/Familiar-Epic-Dobberman.png`,
  "Leopard":             `${CDN}/Familiar-Rare-Leopard.png`,
  "Red Panda":           `${CDN}/Familiar-Rare-RedPanda.png`,
  "Tiger":               `${CDN}/Familiar-Rare-Tiger.png`,
  "Lulu Koi":            `${CDN}/Familiar-Legendary-LuluKoi.png`,
  "Scorpio":             `${CDN}/Familiar-Legendary-Scorpio.png`,
  // Head
  "Focus Headset":       `${CDN}/Head-common-FocusHeadset.png`,
  "Training Visor":      `${CDN}/Head-Common-TrainingVisor.png`,
  "White Bandana":       `${CDN}/Head-Common-WhiteBandana.png`,
  "Cyborg Implant":      `${CDN}/Head-Epic-CyborgImplant.png`,
  "Red Devil Horns":     `${CDN}/Head-Legendary-RedDevilHorns.png`,
  "Holy Halo":           `${CDN}/Head-Legendary-HolyHalo.png`,
  "Solar Holo Shades":   `${CDN}/Head-Rare-SolarHoloShades.png`,
  "Speed Orange Shades": `${CDN}/Head-Rare-SpeedOrangeShades.png`,
  // Shoes
  "Recovery Crocs":      `${CDN}/Shoes-Common-RecoveryCrocs.png`,
  "Neon Cleats":         `${CDN}/Shoes-Epic-Neon-Cleats.png`,
  "Space Sport Shoes":   `${CDN}/Shoes-Epic-SpaceSportKit.png`,
  "Instinct Cleats":     `${CDN}/Shoes-Legendary-InstinctCleats.png`,
  "Black Topo Cleats":   `${CDN}/Shoes-Rare-BlackTopoCleats.png`,
  "Reflective Cleats":   `${CDN}/Shoes-Rare-ReflectiveCleats.png`,
  // Top
  "Orange Backup Jersey": `${CDN}/Top-Common-OrangeBackupJersey.png`,
  "Ordinary Kit":         `${CDN}/Top-Common-OrdinaryKit.png`,
  "Leopard Kit":          `${CDN}/Top-Common-LeopardKit.png`,
  "Signed 98 Kit":        `${CDN}/Top-Epic-Signed98Kit.png`,
  "Energy Kit":           `${CDN}/Top-Epic-EnergyKit.png`,
  "Eastern Silk Kit":     `${CDN}/Top-Legendary-EasternSilkKit.png`,
  "Space Sport Kit":      `${CDN}/Top-Legendary-SpaceSportKit.png`,
  "Black Topo Kit":       `${CDN}/Top-Rare-BlackTopoKit.png`,
  "Blue Geo Kit":         `${CDN}/Top-Rare-BlueGeoKit.png`,
  "Hoop Streetwear":      `${CDN}/Top-Rare-HoopStreetwear.png`,
  "Pink Fire Kit":        `${CDN}/Top-Rare-PinkFireKit.png`,
};

// ── Miniatures inventaire (affichées dans ItemCard / ItemToken) ───────────────
export const INVENTORY_IMGS: Record<string, string> = {
  // Ball
  "Beach Plastic Ball":  `${CDN}/Inventory-Ball-Common-BeachPlasticBall.png`,
  "Geometric Style":     `${CDN}/Inventory-Ball-Common-GeometricStyle.png`,
  "Vintage Ball":        `${CDN}/Inventory-Ball-Epic-VintageBall.png`,
  "Power Ball":          `${CDN}/Inventory-Ball-Legendary-PowerBall.png`,
  "World Cup 26":        `${CDN}/Inventory-Ball-Rare-WorldCup26.png`,
  // Familiar
  "Dobberman":           `${CDN}/Inventory-Familiar-Epic-Dobberman.png`,
  "Leopard":             `${CDN}/Inventory-Familiar-Rare-Leopard.png`,
  "Red Panda":           `${CDN}/Inventory-Familiar-Rare-RedPanda.png`,
  "Tiger":               `${CDN}/Inventory-Familiar-Rare-Tiger.png`,
  "Lulu Koi":            `${CDN}/Inventory-Familiar-Legendary-LuluKoi.png`,
  "Scorpio":             `${CDN}/Inventory-Familiar-Legendary-Scorpio.png`,
  // Head
  "Focus Headset":       `${CDN}/Inventory-Head-common-FocusHeadset.png.png`,
  "Training Visor":      `${CDN}/Inventory-Head-Common-TrainingVisor.png`,
  "White Bandana":       `${CDN}/Inventory-Head-Common-WhiteBandana.png`,
  "Cyborg Implant":      `${CDN}/Inventory-Head-Epic-CyborgImplant.png`,
  "Red Devil Horns":     `${CDN}/Inventory-Head-Legendary-RedDevilHorns.png`,
  "Holy Halo":           `${CDN}/Inventory-Head-Legendary-HolyHalo.png`,
  "Solar Holo Shades":   `${CDN}/Inventory-Head-Rare-SolarHoloShades.png`,
  "Speed Orange Shades": `${CDN}/Inventory-Head-Rare-SpeedOrangeShades.png`,
  // Shoes
  "Recovery Crocs":      `${CDN}/Inventory-Shoes-Common-RecoveryCrocs.png`,
  "Neon Cleats":         `${CDN}/Inventory-Shoes-Epic-Neon%20Cleats.png`,
  "Space Sport Shoes":   `${CDN}/Inventory-Shoes-Epic-SpaceSportKit.png`,
  "Instinct Cleats":     `${CDN}/Inventory-Shoes-Legendary-InstinctCleats.png`,
  "Black Topo Cleats":   `${CDN}/Inventory-Shoes-Rare-BlackTopoCleats.png`,
  "Reflective Cleats":   `${CDN}/Inventory-Shoes-Rare-ReflectiveCleats.png`,
  // Top
  "Orange Backup Jersey": `${CDN}/Inventory-Top-Common-OrangeBackupJersey.png`,
  "Ordinary Kit":         `${CDN}/Inventory-Top-Common-OrdinaryKit.png`,
  "Leopard Kit":          `${CDN}/Inventory-Top-Common-LeopardKit.png`,
  "Signed 98 Kit":        `${CDN}/Inventory-Top-Epic-Signed98Kit.png`,
  "Energy Kit":           `${CDN}/Inventory-Top-Epic-EnergyKit.png`,
  "Eastern Silk Kit":     `${CDN}/Inventory-Top-Legendary-EasternSilkKit.png`,
  "Space Sport Kit":      `${CDN}/Inventory-Top-Legendary-SpaceSportKit.png`,
  "Black Topo Kit":       `${CDN}/Inventory-Top-Rare-BlackTopoKit.png`,
  "Blue Geo Kit":         `${CDN}/Inventory-Top-Rare-BlueGeoKit.png`,
  "Hoop Streetwear":      `${CDN}/Inventory-Top-Rare-HoopStreetwear.png`,
  "Pink Fire Kit":        `${CDN}/Inventory-Top-Rare-PinkFireKit.png`,
  // Background — icône générique unique partagée par tous les fonds en inventaire
  "Vestiaires":           `${CDN}/Inventory-Background-Anybackground.png`,
  "Seoul Street":         `${CDN}/Inventory-Background-Anybackground.png`,
  "Namsan Tower":         `${CDN}/Inventory-Background-Anybackground.png`,
  "Ancient Jungle":       `${CDN}/Inventory-Background-Anybackground.png`,
  "Winter Paris":         `${CDN}/Inventory-Background-Anybackground.png`,
  "Lost Galaxy":          `${CDN}/Inventory-Background-Anybackground.png`,
  "Tokyo Apocalypse":     `${CDN}/Inventory-Background-Anybackground.png`,
};

// Backwards-compat aliases (anciens noms utilisés dans ITEM_IMAGES / FAMILIER_IMAGES)
export const ITEM_IMAGES = INVENTORY_IMGS;
export const FAMILIER_IMAGES = INVENTORY_IMGS;

// ── Fonds (arrière-plan équipé derrière le personnage) ───────────────────────
export const BACKGROUND_IMGS: Record<string, string> = {
  "Vestiaires":        "https://i.postimg.cc/BbM7ZTWb/Fond-Vestiaire-(2).png",
  "Seoul Street":      "https://i.postimg.cc/D02YKCNL/Fond-Street-(2).png",
  "Namsan Tower":      "https://i.postimg.cc/2y29jQp3/Fond-Itaewon-(2).png",
  "Ancient Jungle":    `${CDN}/Background-Rare-AncientJungle.png`,
  "Winter Paris":      `${CDN}/Background-Epic-WinterParis.png`,
  "Lost Galaxy":       `${CDN}/Background-Legendary-LostGalaxy.png`,
  "Tokyo Apocalypse":  `${CDN}/Background-Legendary-TokyoApocalypse.png`,
};

// ── Slots d'équipement ───────────────────────────────────────────────────────
// rollable: false → n'apparaît pas dans mkItem (packs standard / premium)
export const SLOT_DEFS = [
  { key: "head",       label: "Head",       emoji: "🪖",  stats: ["technique", "defense"] },
  { key: "top",        label: "Kit",        emoji: "🎽",  stats: ["defense", "vitesse"] },
  { key: "shoes",      label: "Shoes",      emoji: "👟",  stats: ["technique", "vitesse"] },
  { key: "ball",       label: "Ball",       emoji: "⚽",  stats: ["physique", "technique"] },
  {
    key: "background",
    label: "Background",
    emoji: "🖼️",
    iconImg: "https://i.postimg.cc/FsLKwD0w/Item-icon-for-Backgrounds.png",
    rollable: true,
    stats: ["physique", "vitesse"],
  },
  { key: "familiar",   label: "Companion",  emoji: "🐾",  rollable: true, stats: ["physique", "defense"] },
] as const;

export const SLOT = Object.fromEntries(SLOT_DEFS.map((s) => [s.key, s]));

// ── Noms d'items par slot × rareté ───────────────────────────────────────────
export const INAMES: Record<string, Record<string, string[]>> = {
  head: {
    commun: ["Training Visor", "White Bandana", "Focus Headset"],
    rare:   ["Solar Holo Shades", "Speed Orange Shades"],
    epic:   ["Cyborg Implant"],
    ultra:  ["Red Devil Horns", "Holy Halo"],
  },
  top: {
    commun: ["Ordinary Kit", "Orange Backup Jersey", "Leopard Kit"],
    rare:   ["Black Topo Kit", "Blue Geo Kit", "Hoop Streetwear", "Pink Fire Kit"],
    epic:   ["Signed 98 Kit", "Energy Kit"],
    ultra:  ["Eastern Silk Kit", "Space Sport Kit"],
  },
  shoes: {
    commun: ["Recovery Crocs"],
    rare:   ["Black Topo Cleats", "Reflective Cleats"],
    epic:   ["Neon Cleats", "Space Sport Shoes"],
    ultra:  ["Instinct Cleats"],
  },
  ball: {
    commun: ["Beach Plastic Ball", "Geometric Style"],
    rare:   ["World Cup 26"],
    epic:   ["Vintage Ball"],
    ultra:  ["Power Ball"],
  },
  background: {
    commun: ["Vestiaires"],
    rare:   ["Seoul Street", "Ancient Jungle"],
    epic:   ["Namsan Tower", "Winter Paris"],
    ultra:  ["Lost Galaxy", "Tokyo Apocalypse"],
  },
  familiar: {
    commun: [],
    rare:   ["Leopard", "Red Panda", "Tiger"],
    epic:   ["Dobberman"],
    ultra:  ["Lulu Koi", "Scorpio"],
  },
};

// ── Statistiques d'action ────────────────────────────────────────────────────
// Ordre d'affichage : la Vie (HP) toujours en premier, partout où les stats sont
// listées (Profil, radar, items, delta Duel, Classement). Modifier ici = global.
export const STATS: { key: string; label: string; short: string; icon: string; color: string; emoji?: string }[] = [
  { key: "vitesse",   label: "Health",    short: "HP",  icon: `${CDN}/Stat-speed%20(1).png`,      color: "#A855F7", emoji: "❤️" },
  { key: "physique",  label: "Physique",  short: "PHY", icon: `${CDN}/Stat-physic%20(1).png`,     color: "#F97316" },
  { key: "technique", label: "Technique", short: "TEC", icon: `${CDN}/Stat-technique%20(1).png`,  color: "#2DE36B" },
  { key: "defense",   label: "Défense",   short: "DEF", icon: `${CDN}/Stats-Defense%20(1).png`,   color: "#3B82F6" },
];

// Ordre canonique complet (stats + affixes) pour trier les listes de stats des
// items — Vie d'abord, puis Physique, Technique, Défense, puis énergie/blessure.
export const STAT_DISPLAY_ORDER = ["vitesse", "physique", "technique", "defense", "energy", "blessure"];

export const STAT_CONFIG: Record<string, { count: number; values: number[] }> = {
  commun: { count: 1, values: [5] },
  rare:   { count: 2, values: [8, 4] },
  epic:   { count: 3, values: [12, 8, 4] },
  ultra:  { count: 3, values: [12, 8, 4] },
};

export const ALL_STAT_KEYS = ["technique", "defense", "physique", "vitesse"];

export const STAT_KEY_MIGRATION: Record<string, string> = {
  technicite:   "technique",
  recuperation: "defense",
  puissance:    "physique",
  esprit:       "vitesse",
  // anciens slots fusionnés dans top
  tshirt:   "top",
  jersey:   "top",
  short:    "top",
  // renommages de slots
  casquette:  "head",
  chaussures: "shoes",
  ballon:     "ball",
  familier:   "familiar",
};

export const ITEM_LEVEL_CAP = 100;

export const RARITY_BASE: Record<string, number> = {
  commun: 16,
  rare:   22,
  epic:   28,
  ultra:  34,
};

export const SELL_PRICE: Record<string, number> = {
  commun: 20,
  rare:   80,
  epic:   500,
  ultra:  1000,
};

// ── Capacité d'inventaire (feature mailbox) ───────────────────────────────────
// Cap SOFT : ne bloque que les NOUVEAUX ajouts, ne supprime jamais l'overflow
// existant. Les items ÉQUIPÉS vivent dans `inventory` mais n'occupent PAS de slot
// de sac → ils sont exclus du décompte. Équiper, vendre ou ranger libère une place.
export const INVENTORY_CAP = 16;
// Nombre max de récompenses parkées en attendant une place. Au-delà, le gain est
// auto-converti en coins (jamais perdu). Voir migration_pending_items.sql.
export const PENDING_CAP = 3;

/** Nombre d'items qui comptent dans la capacité = items NON équipés. */
export const countedInventory = (
  inv: { iid: string }[] | null | undefined,
  equipped: Record<string, string | null> | null | undefined
): number => {
  if (!inv?.length) return 0;
  const eq = new Set(Object.values(equipped ?? {}).filter(Boolean));
  return inv.reduce((n, it) => (eq.has(it.iid) ? n : n + 1), 0);
};

/** Vrai quand l'inventaire (hors items équipés) a atteint sa capacité. */
export const inventoryIsFull = (
  inv: { iid: string }[] | null | undefined,
  equipped: Record<string, string | null> | null | undefined
): boolean => countedInventory(inv, equipped) >= INVENTORY_CAP;

// ── Coffre (rangement manuel, extensible) ─────────────────────────────────────
export const COFFRE_SLOTS_PER_CHEST = 20;
export const COFFRE_CHEST_COST_TICKETS = 15;
export const MAX_COFFRE_CHESTS = 5; // onglets 1..5 (5 × 20 = 100 slots max)

/** Capacité totale du coffre = nombre de coffres possédés × 20 (défaut 1 coffre). */
export const coffreCapacity = (coffreCount: number | null | undefined): number =>
  Math.max(1, coffreCount ?? 1) * COFFRE_SLOTS_PER_CHEST;

/** Vrai quand le coffre est plein pour le nombre de coffres possédés. */
export const coffreIsFull = (
  coffreItems: unknown[] | null | undefined,
  coffreCount: number | null | undefined
): boolean => (coffreItems?.length ?? 0) >= coffreCapacity(coffreCount);
